import { Smartphone } from "lucide-react";

/**
 * Shown inside the native app when commerce is disabled (internal test builds).
 * Stripe is never rendered in the native shell.
 */
export function PaymentsUnavailableNotice({ message }: { message?: string }) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-border bg-muted/40 p-4 text-sm text-muted-foreground">
      <Smartphone className="mt-0.5 h-4 w-4 shrink-0" />
      <p>
        {message ??
          "As subscrições e compras não estão disponíveis nesta versão da aplicação. Podes gerir o teu plano em routify-tour.com."}
      </p>
    </div>
  );
}
